import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ValAddSoakingDto } from './val-addition-soaking.dto';

export class ValAdditionSoakingResponseModel extends GlobalResponseObject{
    data?: ValAddSoakingDto;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: ValAddSoakingDto){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }

}